// src/pages/ProtectedRoute.jsx
// Route guard for pages that require any logged-in user.
// If logged in, it renders the wrapped page. If not, it redirects to /login,
// remembering the attempted location so Login can send them back afterward.
// Used as: <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function ProtectedRoute({ children }) {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
